import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import Tooltip from "../components/Tooltip";
import "./DesarrolloWeb.css";
import ContactModal from "../components/ContactModal/ContactModal";

function CMS() {
	const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <SEO
        title="CMS y Contenidos | WordPress, Elementor y Avada"
        description="Gestión de contenidos profesional con WordPress, Elementor y Avada. Sitios fáciles de administrar y optimizados."
        url="https://juancarlosmancharamos.ar/cms"
      />

      <Menu />

      <HeroInner
        title="CMS y Contenidos"
        subtitle="WordPress, Elementor y Avada para gestionar tu web de forma simple"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <div className="dev-inner-wrap">
          
          {/* Encabezado y Texto Principal (Sin Imagen) */}
          <div className="dev-header">
            {/* Quitamos la clase 'h2first' para que respete el margen natural */}
            <div className="dev-intro-content">
              <h2 className="dev-title">Gestión Web Simple y Profesional</h2>
              <p className="dev-lead">
                Toma el control total de tu sitio. Desarrollo plataformas autoadministrables con <strong>WordPress, Elementor y Avada</strong>, diseñadas para que gestiones tu contenido de forma intuitiva y sin depender de terceros.
              </p>
              <p>
                Olvídate de los dolores de cabeza técnicos. Construyo sitios dinámicos y a medida donde actualizar un texto, subir imágenes o publicar un artículo en tu blog es tan fácil como usar un procesador de textos, manteniendo siempre un rendimiento impecable.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
              </div>
              <h3>Autogestión Intuitiva</h3>
              <p>Actualiza textos, banners y publicaciones en tiempo real sin tocar una sola línea de código ni conocimientos técnicos previos.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
              </div>
              <h3>Constructores Premium</h3>
              <p>Maquetación avanzada utilizando Elementor y Avada para garantizar diseños visualmente impactantes, únicos y 100% responsivos.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19.07 4.93a10 10 0 0 0-14.14 0l1.42 1.41a8 8 0 1 1 0 11.32l-1.42 1.41a10 10 0 1 0 14.14-14.14z"></path><path d="M8 9l4-4 4 4"></path><path d="M12 5v14"></path></svg>
              </div>
              <h3>Escalabilidad Total</h3>
              <p>Tu web crece contigo. Integración fluida mediante plugins para añadir funciones como CRMs, pasarelas de pago y herramientas de marketing.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
              </div>
              <h3>Seguridad y Optimización</h3>
              <p>Configuraciones de seguridad robustas, prevención de spam y optimización de caché para una carga veloz y segura.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) */}
          <div className="dev-cta-banner">
            <h3>¿Necesitas una web que tú mismo puedas administrar?</h3>
            <p>Hablemos sobre tu proyecto y construyamos una plataforma que te dé total libertad.</p>
            <button onClick={() => setIsModalOpen(true)} className="dev-btn-primary" style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}>
			  Solicitar Presupuesto
			</button>
          </div>
          
        </div>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />
	  <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="CMS y Contenidos" 
      />
    </>
  );
}

export default CMS;